<mj-record-form-container [Record]="record" [FormComponent]="this"
    (Navigate)="OnFormNavigate($event)"
    (DeleteRequested)="OnDeleteRequested()"
    (FavoriteToggled)="OnFavoriteToggled()"
    (HistoryRequested)="OnHistoryRequested()"
    (ListManagementRequested)="OnListManagementRequested()">

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="before-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         FIELD PANELS
         ======================================== -->
    <!-- Details Section -->
    <mj-collapsible-panel
        SectionKey="details"
        SectionName="Details"
        Icon="fa fa-align-left"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="QuestionText"
            Type="textarea"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Description"
            Type="textarea"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ReviewQuestionTypeID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Sequence"
            Type="number"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="IsRequired"
            Type="checkbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="PresentationCategoryID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Status"
            Type="select"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_CreatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_UpdatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="SeasonID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="FormType"
            Type="select"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>

    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         RELATED ENTITY PANELS
         ======================================== -->

    <!-- Review Question Rubrics Section -->
    <mj-collapsible-panel
        SectionKey="reviewQuestionRubrics"
        SectionName="Review Question Rubrics"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('reviewQuestionRubrics')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Review Question Rubrics','ReviewQuestionID')"
                [NewRecordValues]="NewRecordValues('Review Question Rubrics')"
                [AllowLoad]="IsSectionExpanded('reviewQuestionRubrics')"
                [ShowToolbar]="false"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('reviewQuestionRubrics', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Review Responses Section -->
    <mj-collapsible-panel
        SectionKey="reviewResponses"
        SectionName="Review Responses"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('reviewResponses')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Review Responses','ReviewQuestionID')"
                [NewRecordValues]="NewRecordValues('Review Responses')"
                [AllowLoad]="IsSectionExpanded('reviewResponses')"
                [ShowToolbar]="false"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('reviewResponses', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Nomination Responses Section -->
    <mj-collapsible-panel
        SectionKey="nominationResponses"
        SectionName="Nomination Responses"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('nominationResponses')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Nomination Responses','ReviewQuestionID')"
                [NewRecordValues]="NewRecordValues('Nomination Responses')"
                [AllowLoad]="IsSectionExpanded('nominationResponses')"
                [ShowToolbar]="false"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('nominationResponses', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-related" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>
</mj-record-form-container>
        